import React from 'react';
import './SubcategoryItemLoader.css';
import { useAsg3DotsFlashing } from '../../../../../shared/src/hooks/use-asg-animations.hook';

export const SubcategoryItemLoader = () => {
    const { animationClassName } = useAsg3DotsFlashing();

    return <div className="asg-subcategories__item asg-subcategories__item--loader">
        <div className={animationClassName}></div>
    </div>;
};
